import React from 'react'
import LandingView from '../../templates/landing/LandingView'

const Landing = () => {
    return (
        <LandingView />
    )
}

export default Landing